import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { gql } from "../../__generated__";
import { AppealSectionStatus } from "../../__generated__/graphql";
import { useRequiredParams } from "../../utils/hooks/use-required-params";
import PathConstants from "../../routes/path-constants";

export type SectionLockField =
  | "surveySection"
  | "finalizeAndSubmitSection"
  | "generateAndReviewSection";

export const SECTION_LOCK_OVERVIEW_QUERY = gql(`
  query SectionLockOverview($appealId: ID!) {
    appealOverview(appealId: $appealId) {
      appealId
      surveySection {
        status
      }
      finalizeAndSubmitSection {
        status
      }
      generateAndReviewSection {
        status
      }
    }
  }
`);

interface SectionLockGateProps {
  section: SectionLockField;
}

export function SectionLockGate({ section }: SectionLockGateProps) {
  const { appealId } = useRequiredParams<"appealId">();
  const navigate = useNavigate();

  const { loading, error, data } = useQuery(SECTION_LOCK_OVERVIEW_QUERY, {
    variables: { appealId },
    fetchPolicy: "no-cache",
  });

  const appealDetailPath = PathConstants.MyAppealsDetail.replace(
    ":appealId",
    appealId,
  );

  const sectionData = data?.appealOverview?.[section];
  const status = sectionData?.status;
  const isLocked = !loading && !error && status === AppealSectionStatus.Locked;

  useEffect(() => {
    if (isLocked) {
      navigate(appealDetailPath, { replace: true });
    }
  }, [isLocked, appealDetailPath, navigate]);

  if (loading) return null;

  return <Outlet />;
}
